import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton/index.jsx";
import LdsBlockList from "../../components/LdsBlockList/LdsBlockList.jsx";

import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_5_0_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <div className="col-sm-8 module-content">
        <main className="module-content">
          <section className="mb-5 learning-heading">
            <h1 className="blue text-uppercase b mt-5">
              5.0.1 Indications for Ordering
            </h1>
            <p className="mt-3 mb-0">Estimated time to complete: 1 minute</p>
          </section>
          <section>
            <LdsBlockList
              items={[
                {
                  title: "Indications for Ordering",
                  bookmarked: false,
                  iconSlug: "pin",
                },
                {
                  title: "Technique",
                  bookmarked: false,
                  iconSlug: "wrench",
                  active: false,
                },
                {
                  title: "Findings",
                  bookmarked: true,
                  iconSlug: "memo",
                  active: false,
                },
                {
                  title: "Impression",
                  bookmarked: true,
                  iconSlug: "mag",
                  active: false,
                },
              ]}
            />
            <div className="content-block callout mb-5 mt-3">
              <h2 className="h5 bold">1. Indications for Ordering</h2>
              <ul>
                <li className="bold">
                  State the specific clinical symptoms of mild cognitive
                  impairment (MCI) or dementia
                </li>
                <li>Document the reason(s) for testing, such as</li>
                <ul>
                  <li>Uncertain clinical diagnosis</li>
                  <li>Atypical age of onset</li>
                  <li>Known comorbidities</li>
                  <li>Clinical trial involvement</li>
                </ul>
              </ul>
            </div>
          </section>
          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-5/module-5-0-0", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-5/module-5-0-2", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Module_5_0_1;
